/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import { Table, Button, Row, Col, Card, InputNumber,Input, Select, Checkbox, DatePicker, Icon, Modal, Form, Radio,notification,Tabs , } from 'antd';
import { post } from '../axios';
import BreadcrumbCustom from './BreadcrumbCustom';
import BMap from 'BMap';
import {getParams} from '../utils';
import title from '@/style/imgs/all/title.png';
import gcmt from '@/style/imgs/all/gcmt.png';
import dianhua from '@/style/imgs/all/dianhua.png';
import jmf from '@/style/imgs/all/jmf.png';
const Option = Select.Option;
const RadioGroup = Radio.Group;
const { TextArea } = Input;
const FormItem = Form.Item;
const Search = Input.Search;
const TabPane = Tabs.TabPane;
let map ;

class LxwmFrom extends React.Component {
    state = {
        confirmDirty: false,
        showChoiceVisible: false,
        loading: false,
        type:"新建订单",
        disabled:false,
        helpMapSearch:false
    };
    componentDidMount() {
        const {history} = this.props;
        const thisClass=this;
        let myValue;
        map = new BMap.Map("allmap", { minZoom: 5, maxZoom: 22 }); // 创建Map实例  //  设置地图允许的最小/大级别
        map.enableScrollWheelZoom(); //启用滚轮放大缩小
        map.centerAndZoom("杭州", 11); // 初始化地图,用城市名设置地图中心点   // 级别11 是比较合适的
        const ac = new BMap.Autocomplete(    //建立一个自动完成的对象
            {"input" : "J_rescue_detail_address"
                ,"location" : map
            });
        ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
            var _value = e.item.value;
            myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            setPlace();
        });
        function setPlace (){
             thisClass.setState({ 
                 helpMapSearch:true,
             })
            var localResult=new BMap.LocalSearch(map, {
                renderOptions: {map:map,panel: "searchResultPanel"}, pageCapacity:5
            });
            localResult.disableFirstResultSelection();
            localResult.setInfoHtmlSetCallback(function(poi){
                thisClass.setState({
                    helpMapSearch:false,
                })
                const pp = poi.point;
                thisClass.props.form.setFieldsValue({
                    lng:pp.lng,
                    lat:pp.lat,
                    address:myValue
                })
                map.centerAndZoom(pp, 14);
                const driving = new BMap.DrivingRoute(map, {renderOptions:{map: map, autoViewport: true},onSearchComplete:function(results){

                }});
                var marker =poi.marker; // 创建起点标注
                marker.enableDragging();//开启拖拽功能
                const geoc = new BMap.Geocoder();
                marker.addEventListener("dragend",function(e){
                    var pt = e.point;
                    thisClass.props.form.setFieldsValue({
                        lng:pt.lng,
                        lat:pt.lat
                    })
                    var geoc = new BMap.Geocoder();
                    geoc.getLocation(pt, function(rs) {
                        var addComp = rs.addressComponents;
                        thisClass.props.form.setFieldsValue({
                            address:addComp
                        })

                    })
                })
            });
            localResult.search(myValue)
        }
    }
    sureAdd = () =>{
        this.handleSubmit();
    }
    handleSubmit = (e) => {
        this.setState({
            disabled:true
        })
        this.props.form.validateFields((err, values) => {
            if (!err) {
                for(const i in values){
                    if(!values[i] && values[i]!=0){
                        values[i]="";
                    }
                }
                    post('/common/home-page-contact.htm', values).then(res => {
                        if(res.status==1){
                            const {history} = this.props;
                                notification["success"]({
                                    message: '新增成功',
                                    description: '',
                                });
                            this.setState({
                                disabled:false
                            })
                        }else if(res.status==0){
                            Modal.error({
                                title: "错误",
                                content: res.message,
                            });
                            this.setState({
                                disabled:false
                            })
                            return;
                        }
                    })

            }else {
                this.setState({
                    disabled:false
                })
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="content-right">
                <BreadcrumbCustom first="飞马救援"  second="联系我们"  />
                    <Col style={{position:"relative",width:962}}>
                        <Col style={{width:"962px",paddingLeft:26,marginTop:46,height:850,background:"#fff",border:"1px solid #ccc"}}>
                            <Col style={{overflow:"hidden",paddingTop:46}}><img style={{float:"left",marginTop:6}} src={title} alt=""/><span style={{fontWeight:"bold",marginLeft:8,fontSize:18,color:"#282828",float:"left"}}>联系我们</span></Col>
                            <Col style={{borderBottom:"1px solid #ddd",marginTop:20,width:880}}></Col>
                            <Row>
                                <div>
                                    <Col>
                                        <Form onSubmit={this.handleSubmit}>
                                            <div style={{marginTop:45}}  className="addForm">
                                                <FormItem
                                                    label="单位名称"
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 19 }}
                                                >
                                                    {getFieldDecorator('company',{
                                                    })(
                                                        <Input style={{width:312}}    placeholder="请输入单位名称" />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label="联系人名"
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 19 }}
                                                >
                                                    {getFieldDecorator('name',{
                                                    })(
                                                        <Input style={{width:312}}    placeholder="请输入联系人名" />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label="联系电话"
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 19 }}
                                                >
                                                    {getFieldDecorator('tel',{
                                                    })(

                                                        <Input type="number" style={{width:312}}    placeholder="请输入联系电话" />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    label="具体地址"
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 19}}
                                                >
                                                    {getFieldDecorator('address',{
                                                    })(
                                                        <div>
                                                            <Input  id="J_rescue_detail_address"  style={{ width:400}}     placeholder="请输入救援地址" />
                                                            <span style={{fontSize:16,color:"#d2a475",marginLeft:34}}>输入完成，定位</span>
                                                        </div>

                                                    )}
                                                    {getFieldDecorator('lng',)(
                                                        <Input   style={{ display:"none"}}      />
                                                    )}
                                                    {getFieldDecorator('lat',)(
                                                        <Input  style={{ display:"none"}}     />
                                                    )}
                                                    <div style={{position:"relative"}}>
                                                        <div style={{zIndex:999,width:400,position:"absolute",left: 0,top:0,display:this.state.helpMapSearch?"block":"none"}}  id="searchResultPanel"></div>
                                                    </div>

                                                </FormItem>
                                                <Col style={{width:700,overflow:"hidden", marginTop:20,marginLeft:43,border:"1px solid #ccc"}}>
                                                    <Col style={{width:700,height:280}} id="allmap" ></Col>
                                                </Col>
                                                <FormItem className="addButton">
                                                    <div style={{marginTop:40,float:"right",marginRight:188,}}>
                                                        <span style={{fontSize:15,color:"#333",}}>（我们会尽快联系您，谢谢您的信赖！）</span>
                                                        <Button disabled={this.state.disabled} style={{border:"none",width:180,backgroundColor:"#d2a475",height:40}} onClick={this.sureAdd}  type="primary"  className="login-form-button">
                                                            提交信息
                                                        </Button>
                                                    </div>

                                                </FormItem>
                                            </div>
                                        </Form>
                                    </Col>
                                </div>

                            </Row>
                        </Col>
                        <div style={{position:"absolute",top:126,right:30}}>
                            <Col>
                                <img src={gcmt} alt=""/>
                            </Col>
                            <Col style={{marginTop:8,fontSize:16,color:"#333",textAlign:"right"}}>
                                <span>联系我们</span><img style={{marginTop:-1}} src={jmf} alt=""/>
                            </Col>
                            <Col style={{marginTop:8,fontSize:16,color:"#333",textAlign:"right",marginRight:21}}>
                                <img style={{marginRight:14,marginTop:-1}} src={dianhua} alt=""/><span>0571-85269628</span>
                            </Col>
                        </div>
                    </Col>
            </div>

        );
    }
}

const Lxwm = Form.create()(LxwmFrom);


export default Lxwm;


// WEBPACK FOOTER //
// ./src/components/lxwm.jsx